// This file is auto-generated by scripts/generate-models.ts
// Do not edit manually - run 'npm run generate-models' to update

import values from "./data/moonshotai.json" with { type: "json" };
import { flattenModelCatalog, type ModelCatalog } from "../model-catalog.ts";

export const MOONSHOTAI_MODELS: ModelCatalog<typeof values, "moonshotai"> =
	flattenModelCatalog("moonshotai", values);
